import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import PlatformHeader from '../appComponents/mobile/PlatformHeader';
import MobileViewport from '../appComponents/mobile/MobileViewport';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import './css/AccountSettingsPolish.css';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import React, { Component } from 'react';

import '../appComponents/mobile/css/MobileExperience.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
import '../appComponents/mobile/css/MobileHardening.css';
import '../appComponents/mobile/css/MobileConsolidated.css';
import './css/AccountManagementMobileRedesign.css';
class AccountManagementMobileRender extends Component {
  // Scroll only the gallery; never scroll the page while tapping gallery arrows.
  // Index is derived from the visible card, so arrows also work after a manual swipe.
  scrollGalleryBy(that, direction) {
    const media = Array.isArray(that.state.mediaMapArray) ? that.state.mediaMapArray : [];
    if (!media.length) return;
    const track = this.accountGalleryTrack;
    const cards = track ? Array.from(track.querySelectorAll('.tbp-am50-post')) : [];
    let current = Number(that.state.lastMediaItemIndexScrolled) || 0;
    if (track && cards.length > 1) {
      const spacing = cards[1].offsetLeft - cards[0].offsetLeft;
      if (spacing > 0) current = Math.round(track.scrollLeft / spacing);
    }
    const next = (Math.max(0, Math.min(media.length - 1, current)) + direction + media.length) % media.length;
    if (track && cards[next]) {
      const left = cards[next].offsetLeft - cards[0].offsetLeft;
      track.scrollTo({ left, behavior: 'smooth' });
    }
    that.setState({ lastMediaItemIndexScrolled: next });
  }

  render() {
    const { API, AWS, Amplify, Auth, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, Storage, ThreeDot, USDEtherConversionRate, Web3, accountmanagement, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderData, blenderPrivateKey, blenderScore, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, fileDialog, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, intRateMax, intRateMin, isMobile, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, web3, wishlistArray } = this.props;

    return (
(
          <div className={"pageBody tbp-mobile-redesign tbp-platform tbp-platform--mobile tbp-platform--" + (that.state.mode_light_dark === "light" ? "light" : "dark") + " tbp-platform--" + "account-management tbp-am50"}>
<MobileViewport />
<MobileOverlayStyles />

              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

          

        
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog tbp-am50-dialog tbp-am50-dialog--error'} open={that.state.errorTags}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 17,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.selectedLanguage == 'spanish' ? 'Error:' : 'Error:'}
                            </p>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.errorTags}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          successfulDepositOverlay: false,
          errorTags: null
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog tbp-am50-dialog tbp-am50-dialog--nickname' + " tbp-nickname-dialog"} open={that.state.publicDisplayNameEditOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        Apodo público
                    </p>
                </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <div style={{
        // flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderRadius: 3,
        borderStyle: 'none',
        borderColor: 'rgba(177, 177, 177, 0)',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%'
      }}>
                    
                    <input type={"text"} id="text" outline="none" autocomplete="off" value={that.state.newDynamicPublicUsername} onChange={event => {
          that.setState({
            newDynamicPublicUsername: event.target.value
          });
        }} name="text" placeholder={that.state.selectedLanguage == 'spanish' ? "Apodo Publico" : "Public Nickname"} style={{
          fontWeight: '600',
          fontFamily: 'arial',
          alignSelf: 'center',
          textAlign: 'center',
          textAlignVertical: 'center',
          borderColor: 'rgba(177, 177, 177, 0)',
          height: 'auto',
          width: '100%',
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: 16,
          paddingRight: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          fontSize: 16,
          maxWidth: '100%',
          minHeight: 48,
          padding: 12,
          margin: 0,
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: '1px solid rgba(128,128,128,.4)',
          borderRadius: 4,
          boxSizing: 'border-box'
        }} />
                  </div>
                  <div style={{
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 15,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%'
      }}>
                    <button onClick={() => {
          authenticatedPut('api1169ba1e', '', {
            headers: {
              Authorization: `Bearer ${cognitoID}`
            },
            body: {
              category: 'db',
              tableName: 'socialUserData',
              primaryKey: that.state.currentUser,
              requestOperation: 'update',
              updateExpression: `SET 
                                  dynamicPublicUsername = :dynamicPublicUsername
                                `,
              expressionAttributeValues: {
                ':dynamicPublicUsername': that.state.newDynamicPublicUsername
              }
            }
          }).then(res => {
            that.setState({
              publicDisplayNameEditOverlay: false,
              successfulUpdateOverlay: true
            });
            setTimeout(() => {
              that.setState({
                successfulUpdateOverlay: false
              });
            }, 3000);
            that.buildData();
          });
        }} style={{
          backgroundColor: 'rgba(0, 158, 129, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginLeft: 0,
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} className="tbp-nickname-choice">{that.state.selectedLanguage === 'spanish' ? 'Guardar' : 'Save'}</button>

                    <button className={"tbp-overlay-cancel"} onClick={() => {
          that.setState({
            publicDisplayNameEditOverlay: false,
            newDynamicPublicUsername: null
          });
          that.buildData();
        }} style={{
          backgroundColor: 'rgba(204, 12, 12, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} className="tbp-nickname-choice">{that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Cancel'}</button>
                  </div>
                </Modal.Description>
              
                
                </Modal.Content>
            </Modal>
 
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog tbp-am50-dialog tbp-am50-dialog--success'} open={that.state.successfulUpdateOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                
                <Modal.Description style={{}}>
                  <Header style={{
        marginTop: 5,
        fontSize: 16,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                    {that.state.selectedLanguage == 'spanish' ? `Su perfíl se ha actualizado.` : `Your profile has been updated.`}
                  </Header>
                  
                </Modal.Description>
              
                
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog tbp-am50-dialog tbp-am50-dialog--delete'} open={that.state.mediaDeleteOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
                                      
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                      The Blender Platform
                  </p>
              </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        paddingRight: 16,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                    <p style={{
          fontSize: 16,
          textAlign: 'left',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                        {that.state.selectedLanguage == 'spanish' ? `Borrar esta media?  ` : `Delete this media?  `}
                      
                    </p>
                    
                  </Header>
                  
                  <div style={{
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 15,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%'
      }}>
                    <Button content={that.state.selectedLanguage === 'spanish' ? 'Eliminar' : 'Delete'} labelPosition='right' icon='trash alternate outline' className='tbp-am50-delete-confirm' onClick={() => {
          authenticatedPut('api1169ba1e', '', {
            headers: {
              Authorization: `Bearer ${cognitoID}`
            },
            body: {
              category: 'db',
              tableName: 'socialUserData',
              primaryKey: String(currentUser),
              requestOperation: 'get'
            }
          }).then(userData => {
            let newMediaArray = [];
            if (userData.hasOwnProperty('Item')) {
              if (userData.Item.hasOwnProperty('mediaArray')) {
                newMediaArray = userData.Item.mediaArray;
                let indexToRemove = newMediaArray.indexOf(that.state.mediaItemToDelete);
                if (indexToRemove >= 0) newMediaArray.splice(indexToRemove, 1);
              }
              authenticatedPut('api1169ba1e', '', {
                headers: {
                  Authorization: `Bearer ${cognitoID}`
                },
                body: {
                  category: 'db',
                  tableName: 'socialUserData',
                  primaryKey: currentUser,
                  requestOperation: 'update',
                  updateExpression: `SET 
                                                mediaArray = :newMediaArray
                                            `,
                  expressionAttributeValues: {
                    ':newMediaArray': newMediaArray
                  }
                }
              }).then(res => {
                that.setState({
                  mediaDeleteOverlay: false,
                  mediaItemToDelete: null
                });
                that.buildData();
              });
            }
          });
        }} positive style={{
          // marginLeft: '2vw',
          backgroundColor: 'rgba(204, 12, 12, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} />

                    <Button className={"tbp-overlay-cancel"} content={that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Cancel'} labelPosition='right' icon='close' onClick={() => {
          that.setState({
            mediaDeleteOverlay: false
          });
        }} positive style={{
          backgroundColor: 'rgba(0, 158, 129, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} />
                  </div>
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>
 
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog tbp-am50-dialog tbp-am50-dialog--language' + " tbp-language-dialog"} open={that.state.selectPrimaryLanguageOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
                          
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                      The Blender Platform
                  </p>
              </Modal.Header>
                

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        paddingRight: 16,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                    <p style={{
          fontSize: 16,
          textAlign: 'left',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                      {that.state.selectedLanguage == 'spanish' ? `Elige tu idioma principal.  ` : `Choose your primary language.  `}
                      
                    </p>
                    
                  </Header>

                  <Modal.Description style={{}}>
                    <div style={{
          flexDirection: 'row',
          justifyContent: 'center',
          padding: 15,
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          height: 'auto',
          width: '100%'
        }}>
                      <button onClick={() => {
            that.setState({
              selectPrimaryLanguageOverlay: false
            });
            that.updatePrimaryLanguage('english');
          }} style={{
            backgroundColor: 'rgba(0, 158, 129, 1)',
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            marginLeft: 0,
            minHeight: 44,
            fontSize: 16,
            lineHeight: 1.4,
            boxSizing: 'border-box',
            margin: 0,
            padding: '12px 16px',
            maxWidth: '100%',
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
          }} className="tbp-language-choice">English</button>

                      <button onClick={() => {
            that.setState({
              selectPrimaryLanguageOverlay: false
            });
            that.updatePrimaryLanguage('spanish');
          }} style={{
            backgroundColor: 'rgba(0, 158, 129, 1)',
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            minHeight: 44,
            fontSize: 16,
            lineHeight: 1.4,
            boxSizing: 'border-box',
            margin: 0,
            padding: '12px 16px',
            maxWidth: '100%',
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
          }} className="tbp-language-choice">Español</button>
                    </div>
                  </Modal.Description>
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>
            
            
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-navigation ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.navigationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <div className="tbp-mobile-menu-panel" style={{
    // borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8vh',
    borderRightStyle: 'solid',
    borderWidth: 0.1,
    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
    padding: '20px',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    border: 0,
    boxSizing: 'border-box',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '100%'
  }}><div style={{
      justifyContent: "space-between",
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 20px',
      width: '100%'
    }} className={'tbp-menu-header'}><div style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        textAlign: 'left',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        flex: 1,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        width: 'auto',
        minWidth: 0
      }} className={'tbp-menu-brand'}> 
                  <div style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 12,
          width: 'auto',
          minWidth: 0
        }}>
                    <img src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} alt="The Blender Platform" style={{
            position: 'static',
            flexShrink: 0,
            width: 28,
            height: 28,
            padding: 0,
            margin: 0,
            objectFit: 'contain'
          }} />
                    <p style={{
            textAlign: 'left',
            marginLeft: 0,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            flex: 1,
            minWidth: 0,
            width: 'auto',
            fontSize: 16,
            lineHeight: 1.4,
            overflowWrap: 'normal',
            wordBreak: 'normal',
            margin: 0
          }}>
                      {'The Blender Platform'}
                        <span className="tbp-menu-username" title={String(currentUser || that.state.currentUser || '')}>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</span>
                    </p>
                  </div>
                </div><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        padding: 0,
        margin: 0
      }} onClick={() => {
        that.setState({
          navigationOverlay: false
        });
      }}> 
                  <svg className="tbp-mobile-menu-close-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" /></svg>
                </Button></div><List className="tbp-mobile-menu-list" style={{
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'stretch',
      height: 'auto',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 16
    }}>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button" onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/home'
            }
          });
        }}>
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="home icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }} />
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Activos' : 'Accounts'}
                      </p>
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/browser'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="search icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Buscar' : 'Browse'}
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/newborrowingacct'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="newspaper icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Tomar Prestamo' : 'Borrow Funds'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/membertransactions'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="wait icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Transacciones' : 'Transactions'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/subscriptionplan'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Profile'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Condiciones' : 'Terms of Use'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Privacidad' : 'Privacy Policy'}
                      </p>
                      
                    </button>
                  </ListItem>
                </List><div className="tbp-mobile-menu-actions" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      borderTop: "1px solid rgba(128,128,128,.25)",
      marginTop: 24,
      paddingTop: 12
    }}><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => {
        trackPageRequest(Auth.signOut());
        that.setState({
          navigationDestinationObject: {
            navigationRoute: '/welcome'
          }
        });
      }}> 
                  <p style={{
          textAlign: 'left',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          width: '100%'
        }}>
                    <i className="sign out icon" style={{
            position: 'static',
            fontSize: 20,
            height: 20,
            lineHeight: 1,
            flexShrink: 0,
            flex: '0 0 22px',
            width: 22,
            margin: 0
          }} />
                    {that.state.selectedLanguage == 'spanish' ? 'Desconectar' : 'Sign Out'}
                  </p>
                </Button><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}>
                  <i style={{
          zIndex: 999,
          textAlign: 'left',
          textAlignVertical: 'top',
          // marginBottom: 0, 
          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)'
          // marginLeft: 5,
          ,

          position: 'static',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} className={that.state.mode_light_dark == 'dark' ? "sun icon" : "moon icon"} />
                </Button></div></div>
            </Modal>  


            {/* v50: Mobile account settings — a single, bounded vertical scroller.
                Keep every original action and state mutation; do not change desktop. */}
            <div className="tbp-am50-shell">
              <PlatformHeader
                  title={that.state.selectedLanguage === 'spanish' ? 'Mi Cuenta' : 'My Account'}
                  language={that.state.selectedLanguage}
                  onHome={() => that.setState({ navigationDestinationObject: { navigationRoute: '/home' } })}
                  onMenu={() => that.setState({ navigationOverlay: true })}
                />

              <main className="tbp-am50-scroll" aria-label={that.state.selectedLanguage === 'spanish' ? 'Administración de cuenta' : 'Account management'}>
                <div className="tbp-am50-content">
                  <div className="tbp-am50-intro">
                    <h2>{that.state.selectedLanguage === 'spanish' ? 'Configuración de cuenta' : 'Account settings'}</h2>
                    <p>{that.state.selectedLanguage === 'spanish'
                      ? 'Personaliza tu perfil público y administra tu contenido.'
                      : 'Personalize your public profile and manage your content.'}</p>
                  </div>

                  <section className="tbp-am50-card tbp-am50-profile" aria-label={that.state.selectedLanguage === 'spanish' ? 'Perfil público' : 'Public profile'}>
                    <div className="tbp-am50-section-heading">
                      <div>
                        <h3>{that.state.selectedLanguage === 'spanish' ? 'Perfil público' : 'Public profile'}</h3>
                        <p>{that.state.selectedLanguage === 'spanish' ? 'Tu foto y biografía' : 'Your photo and biography'}</p>
                      </div>
                    </div>
                    <div className="tbp-am50-identity">
                      <button
                        type="button"
                        className="tbp-am50-avatar-button"
                        aria-label={that.state.selectedLanguage === 'spanish' ? 'Cambiar foto de perfil' : 'Change profile photo'}
                        onClick={() => that.updateProfilePhoto()}
                      >
                        <img
                          src={that.state.socialOverlayData_imageURI || 'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'}
                          alt=""
                          className="tbp-am50-avatar"
                        />
                        <span className="tbp-am50-camera"><i className="camera icon" aria-hidden="true" /></span>
                      </button>
                      <div className="tbp-am50-identity-text">
                        <strong>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</strong>
                        <button type="button" className="tbp-am50-text-action" onClick={() => that.updateProfilePhoto()}>
                          <i className="pencil icon" aria-hidden="true" />
                          {that.state.selectedLanguage === 'spanish' ? 'Cambiar foto' : 'Change photo'}
                        </button>
                      </div>
                    </div>
                    <div className="tbp-am50-field">
                      <label htmlFor="tbp-am50-bio">{that.state.selectedLanguage === 'spanish' ? 'Biografía' : 'Bio'}</label>
                      <textarea
                        id="tbp-am50-bio"
                        rows={4}
                        maxLength={275}
                        value={that.state.socialOverlayData_bioString || ''}
                        placeholder={that.state.selectedLanguage === 'spanish' ? 'Cuéntanos algo de ti…' : 'Tell us a little about yourself…'}
                        onChange={event => that.setState({ socialOverlayData_bioString: event.target.value, bioActivelyEditingBool: true })}
                      />
                      <div className="tbp-am50-bio-foot">
                        <span>{String(that.state.socialOverlayData_bioString || '').length}/275</span>
                        {that.state.bioActivelyEditingBool && (
                          <button className="tbp-am50-primary-button tbp-am50-save-bio" type="button"
                            onClick={()=> {

                                  authenticatedPut('api1169ba1e', '', { 
                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                    body: { 
                                        category: 'db',
                                        tableName: 'socialUserData', 
                                        primaryKey: that.state.currentUser, 
                                        requestOperation: 'update',
                                        updateExpression: 
                                          `SET 
                                            bioString = :bioString
                                          `
                                        ,
                                        expressionAttributeValues: { 
                                          ':bioString': that.state.socialOverlayData_bioString,
                                        }
                                    }
                                  }).then((res) => {
                                    that.setState({
                                      successfulUpdateOverlay: true,
                                      bioActivelyEditingBool: false
                                    })
                                    setTimeout(() => {
                                      that.setState({
                                        successfulUpdateOverlay: false
                                      })
                                    }, 3000)
                                
                                    that.buildData()
                                  })

                                }}>
                            <i className="check icon" aria-hidden="true" />
                            {that.state.selectedLanguage === 'spanish' ? 'Guardar biografía' : 'Save bio'}
                          </button>
                        )}
                      </div>
                    </div>
                  </section>

                  <section className="tbp-am50-card tbp-am50-preferences" aria-label={that.state.selectedLanguage === 'spanish' ? 'Preferencias' : 'Preferences'}>
                    <div className="tbp-am50-section-heading">
                      <div>
                        <h3>{that.state.selectedLanguage === 'spanish' ? 'Preferencias' : 'Preferences'}</h3>
                        <p>{that.state.selectedLanguage === 'spanish' ? 'Tu nombre público e idioma' : 'Public name and language'}</p>
                      </div>
                    </div>
                    <div className="tbp-am50-options">
                      <button type="button" className="tbp-am50-option" onClick={() => that.setState({ publicDisplayNameEditOverlay: true })}>
                        <span className="tbp-am50-option-icon"><i className="address card outline icon" aria-hidden="true" /></span>
                        <span className="tbp-am50-option-body">
                          <strong>{that.state.selectedLanguage === 'spanish' ? 'Apodo público' : 'Public nickname'}</strong>
                          <small>{that.state.selectedLanguage === 'spanish' ? 'Editar nombre visible' : 'Edit your display name'}</small>
                        </span>
                        <i className="angle right icon tbp-am50-option-chevron" aria-hidden="true" />
                      </button>
                      <button type="button" className="tbp-am50-option" onClick={() => that.setState({ selectPrimaryLanguageOverlay: true })}>
                        <span className="tbp-am50-option-icon"><i className="language icon" aria-hidden="true" /></span>
                        <span className="tbp-am50-option-body">
                          <strong>{that.state.selectedLanguage === 'spanish' ? 'Idioma principal' : 'Primary language'}</strong>
                          <small>{that.state.selectedLanguage === 'spanish' ? 'Español' : 'English'}</small>
                        </span>
                        <i className="angle right icon tbp-am50-option-chevron" aria-hidden="true" />
                      </button>
                    </div>
                  </section>

                  <section className="tbp-am50-card tbp-am50-gallery" aria-label={that.state.selectedLanguage === 'spanish' ? 'Galería' : 'Media gallery'}>
                    <div className="tbp-am50-gallery-heading">
                      <div className="tbp-am50-section-heading">
                        <div>
                          <h3>{that.state.selectedLanguage === 'spanish' ? 'Mis publicaciones' : 'My posts'}</h3>
                          <p>{that.state.selectedLanguage === 'spanish'
                            ? 'Fotos, videos y leyendas de tu perfil'
                            : 'Photos, videos, and captions on your profile'}</p>
                        </div>
                        <span className="tbp-am50-count">{(that.state.mediaMapArray || []).length}</span>
                      </div>
                      <button className="tbp-am50-primary-button tbp-am50-upload" type="button"
                        onClick={() => { 
                                fileDialog({ 
                                  multiple: false, 
                                  accept: ['image/*', 'video/*'] 
                                }).then(file => {
                                    if (!file || !file[0]) return;
                                    const data = new FormData()
                                    data.append('file', file[0])

                                    
                                      const reader = new FileReader();
                                  
                                      reader.onload = (e) => {
                                        const uri = e.target.result;

                                        let video_image_type = String(file[0].name).includes('video') ? 'video/mp4' : 'image/jpg';
                                        let video_image_ext = String(file[0].name).includes('video') ? 'mp4' : 'jpg';
                                        var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 18)

                                        let randomID = currentUser.toLowerCase().concat(randomString1)
                                        let fileName = `${currentUser.toLowerCase()}/${randomID}.${video_image_ext}`

                                        trackPageRequest(axios.get(uri, { responseType: 'arraybuffer' })).then((res) => {                                                          
                                          
                                            try{
                                                Storage.put(
                                                    fileName,
                                                    // uri,
                                                    res.data,
                                                    {         
                                                      level: 'public',
                                                    }
                                                ).then((res) => {

                                                    authenticatedPut('api1169ba1e', '', { 
                                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                                        body: { 
                                                            category: 'db',
                                                            tableName: 'socialUserData', 
                                                            primaryKey: currentUser, 
                                                            requestOperation: 'update',
                                                            updateExpression: 
                                                                `SET 
                                                                    mediaArray = list_append(mediaArray, :mediaKey)
                                                                `
                                                            ,
                                                            expressionAttributeValues: { 
                                                                ':mediaKey': [fileName]
                                                            }
                                                        }
                                                    }).then((res) => {

                                                        authenticatedPut('api1169ba1e', '', { 
                                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                                            body: { 
                                                                category: 'db',
                                                                tableName: 'mediaUploads', 
                                                                primaryKey: String(fileName), 
                                                                requestOperation: 'update',
                                                                updateExpression: 
                                                                    `SET 
                                                                        caption = :caption,
                                                                        uploadTimestamp = :uploadTimestamp,
                                                                        likesArray = :likesArray,
                                                                        commentsMapArray = :commentsMapArray
                                                                    `
                                                                ,
                                                                expressionAttributeValues: { 
                                                                    ':caption': '...',
                                                                    ':uploadTimestamp': Number(Date.now()),
                                                                    ':likesArray': [],
                                                                    ':commentsMapArray': [],
                                                                }
                                                            }
                                                        }).then((res) => {
                                                          that.setState({
                                                            successfulUpdateOverlay: true
                                                          })
                                                          setTimeout(() => {
                                                            that.setState({
                                                              successfulUpdateOverlay: false
                                                            })
                                                            that.buildData()
                                                          }, 3000)
                                                        })

                                                    })
                                                })
                                            } catch(err) {
                                            }                                                           

                                        })

                                      };
                                  
                                      reader.readAsDataURL(file[0]);  
                                      
                                })
                              }}>
                        <i className="upload icon" aria-hidden="true" />
                        {that.state.selectedLanguage === 'spanish' ? 'Subir contenido' : 'Upload media'}
                      </button>
                    </div>
                    {(!that.state.mediaMapArray || that.state.mediaMapArray.length === 0) ? (
                      <div className="tbp-am50-empty">
                        <i className="images outline icon" aria-hidden="true" />
                        <strong>{that.state.selectedLanguage === 'spanish' ? 'Aún no tienes publicaciones' : 'No posts yet'}</strong>
                        <p>{that.state.selectedLanguage === 'spanish' ? 'Sube una foto o un video para comenzar.' : 'Upload a photo or video to get started.'}</p>
                      </div>
                    ) : (
                      <>
                        <div className="tbp-am50-gallery-nav">
                          <span>{that.state.selectedLanguage === 'spanish' ? 'Desliza para ver más' : 'Swipe to see more'}</span>
                          <div className="tbp-am50-gallery-arrows">
                            <button type="button" aria-label={that.state.selectedLanguage === 'spanish' ? 'Publicación anterior' : 'Previous post'}
                              onClick={() => this.scrollGalleryBy(that, -1)}>
                              <i className="chevron left icon" aria-hidden="true" />
                            </button>
                            <button type="button" aria-label={that.state.selectedLanguage === 'spanish' ? 'Publicación siguiente' : 'Next post'}
                              onClick={() => this.scrollGalleryBy(that, 1)}>
                              <i className="chevron right icon" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                        <div className="tbp-am50-gallery-track" ref={node => { this.accountGalleryTrack = node; }} aria-label={that.state.selectedLanguage === 'spanish' ? 'Publicaciones, desplazamiento horizontal' : 'Posts, horizontal scroll'}>
                          {that.state.mediaMapArray.map(listItemA => (
                            <article className="tbp-am50-post" id={listItemA.itemIndex} key={listItemA.mediaFileName || listItemA.itemIndex}>
                              <div className="tbp-am50-post-visual">
                                {String(listItemA.mediaURI).toLowerCase().includes('mp4') ? (
                                  <video controls playsInline preload="metadata" className="tbp-am50-post-image"
                                    ref={ref => { that.player = ref; }}
                                    fullscreen={listItemA.mediaURI == that.state.fullScreenViewerURI}>
                                    <source src={listItemA.mediaURI} type="video/mp4" />
                                  </video>
                                ) : (
                                  <img className="tbp-am50-post-image" src={listItemA.mediaURI} alt={that.state.selectedLanguage === 'spanish' ? 'Publicación de perfil' : 'Profile post'} />
                                )}
                                <button
                                  type="button"
                                  className="tbp-am50-delete"
                                  aria-label={that.state.selectedLanguage === 'spanish' ? 'Eliminar publicación' : 'Delete post'}
                                  onClick={() => that.setState({ mediaItemToDelete: listItemA.mediaFileName, mediaDeleteOverlay: true })}
                                >
                                  <i className="trash alternate outline icon" aria-hidden="true" />
                                </button>
                              </div>
                              <div className="tbp-am50-caption-area">
                                <label htmlFor={'tbp-am50-caption-' + listItemA.itemIndex}>
                                  {that.state.selectedLanguage === 'spanish' ? 'Leyenda' : 'Caption'}
                                </label>
                                <textarea
                                  id={'tbp-am50-caption-' + listItemA.itemIndex}
                                  className="tbp-am50-caption"
                                  rows={3}
                                  maxLength={250}
                                  disabled={Boolean(that.state.captionActivelyEditingURI && that.state.captionActivelyEditingURI !== listItemA.mediaURI)}
                                  value={that.state.captionActivelyEditingURI === listItemA.mediaURI
                                    ? (that.state.newCaptionStringInput || '')
                                    : (listItemA.mediaItemCaption || '')}
                                  placeholder={that.state.selectedLanguage === 'spanish' ? 'Escribe una leyenda…' : 'Write a caption…'}
                                  onFocus={() => {
                                    if (that.state.captionActivelyEditingURI !== listItemA.mediaURI) {
                                      that.setState({ captionActivelyEditingURI: listItemA.mediaURI, newCaptionStringInput: listItemA.mediaItemCaption || '' });
                                    }
                                  }}
                                  onChange={event => that.setState({ captionActivelyEditingURI: listItemA.mediaURI, newCaptionStringInput: event.target.value })}
                                />
                                {that.state.captionActivelyEditingURI === listItemA.mediaURI && (
                                  <div className="tbp-am50-caption-actions">
                                    <button type="button" className="tbp-am50-caption-cancel"
                                      onClick={()=> {
                                                that.setState({
                                                  newCaptionStringInput: '',
                                                  captionActivelyEditingURI: null,
                                                })  

                                              }}>
                                      <i className="close icon" aria-hidden="true" />
                                      {that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Cancel'}
                                    </button>
                                    <button type="button" className="tbp-am50-primary-button tbp-am50-caption-save"
                                      onClick={()=> {
                                              
                                                that.setState({
                                                  captionActivelyEditingURI: listItemA.mediaURI,
                                                }, () => {

                                                  authenticatedPut('api1169ba1e', '', { 
                                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                                    body: { 
                                                        category: 'db',
                                                        tableName: 'mediaUploads', 
                                                        primaryKey: String(listItemA.mediaFileName), 
                                                        requestOperation: 'update',
                                                        updateExpression: 
                                                          `SET 
                                                              caption = :caption
                                                          `
                                                        ,
                                                        expressionAttributeValues: { 
                                                          ':caption': that.state.newCaptionStringInput,
                                                        }
                                                    }
                                                  }).then((res) => {
                                                    that.setState({
                                                      captionActivelyEditingURI: null,
                                                      mediaMapArray: (that.state.mediaMapArray || []).map(item =>
                                                        item.mediaFileName === listItemA.mediaFileName
                                                          ? { ...item, mediaItemCaption: that.state.newCaptionStringInput }
                                                          : item
                                                      )
                                                    })
                                                  })
                                                })  

                                              }}>
                                      <i className="check icon" aria-hidden="true" />
                                      {that.state.selectedLanguage === 'spanish' ? 'Guardar' : 'Save'}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </article>
                          ))}
                        </div>
                      </>
                    )}
                  </section>
                </div>
                <PlatformFooter language={that.state.selectedLanguage} mobile />
              </main>
            </div>

          </div>
        )
    );
  }
}

export default AccountManagementMobileRender;
